import { useChannelTalk } from '@repo/channel-talk';
import { useUserEventLogger } from '@repo/tracking-service';
import { BoxButton, Card, List, MainTitle, Svg } from '@repo/ui';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

export const VipCounsel = () => {
  const { pageName, sendClickEvent } = useUserEventLogger();
  const { openChannelTalk } = useChannelTalk();

  return (
    <section className={'py-normal-medium'}>
      <div className={'max-w-[520px] mx-auto page-padding'}>
        <MainTitle
          className={'pt-normal-large pb-normal-medium'}
          title={'예상 환급액이 많아 고민되시나요?'}
          description={'세무 전문가에게 고민하고 있는 점을 이야기해보세요.'}
          size={'small'}
        />
        <Card outline className={'!rounded-bzc-large !py-tiny-medium !px-normal-large'}>
          <List
            size={'medium'}
            overline={'세무 전문가의 1:1 맞춤 상담'}
            title={'궁금한 점 물어보기'}
            leadingElement={<Svg src={'icg_speech-balloon-1on1_md.svg'} width={32} height={32} />}
            secondaryAction={
              <BoxButton
                variant={'tonal-primary'}
                size={'small'}
                onClick={() => {
                  sendClickEvent(`${pageName}_result_supportbot-top`);
                  openChannelTalk(SUPPORT_BOT_LINK.조회완료.VIP개인);
                }}
              >
                상담
              </BoxButton>
            }
          />
        </Card>
      </div>
    </section>
  );
};
